import request from '@/config/axios'

export type HistoryVO = {
  id: number
  contentId: number
  seriesId: number
  seasonId: number
  name: string
  coverUrl: string
  audioUrl: string
  videoUrl: string
  category?: string
  chinese?: string
  english?: string
  isFavorite?: number
  createTime: string
}

export const addHistory = (data: any) => {
  return request.post({
    url: '/user-history/create',
    data
  })
}

export const getHistoryPage = (params: any) => {
  return request.get({
    url: '/user-history/page',
    params
  })
}

export const deleteHistory = (ids: number[]) => {
  return request.delete({
    url: `/user-history/delete-list?ids=${ids.join(',')}`
  })
}
